import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './Components/Home';
import Experiences from './Components/Experiences';
import BarFoodMenu from './Components/BarFoodMenu';
import Safety from './Components/Safety';
import FestivalMap from './Components/FestivalMap';
import ArtistLineUp from './Components/ArtistLineUp';

function App() {
  return (
    <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home/>} />
            <Route path="/artistlineup" element={<ArtistLineUp/>} />
            <Route path="/experiences" element={<Experiences/>} />
            <Route path="/barfoodmenu" element={<BarFoodMenu/>} />
            <Route path="/safety" element={<Safety/>} />
            <Route path="/festivalmap" element={<FestivalMap/>} />
          </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
